import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '@/lib/api';
import { ArrowLeft } from 'lucide-react';

export default function LegalPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/legal/${slug}`).then(({ data }) => setPage(data)).catch(() => setPage(null)).finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--bg-color)', color: 'var(--text-color)' }}><span style={{ fontFamily: 'var(--body-font)', fontSize: '0.7rem', letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--muted-color)' }}>Loading...</span></div>;
  if (!page) return <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--bg-color)', color: 'var(--text-color)' }}><span>Page not found</span></div>;

  return (
    <div data-testid={`legal-${slug}`} className="min-h-screen" style={{ backgroundColor: 'var(--bg-color)', color: 'var(--text-color)' }}>
      <div className="max-w-2xl mx-auto px-6 py-16">
        <Link to="/" className="inline-flex items-center gap-2 mb-8 transition-opacity hover:opacity-70" style={{ fontFamily: 'var(--body-font)', fontSize: '0.7rem', letterSpacing: '0.15em', textTransform: 'uppercase', color: 'var(--muted-color)', textDecoration: 'none' }}>
          <ArrowLeft size={14} />
          Back
        </Link>
        <h1 style={{ fontFamily: 'var(--headline-font)', fontStyle: 'italic', fontSize: 'clamp(1.5rem, 3vw, 2.5rem)', textTransform: 'uppercase', marginBottom: '2rem' }}>
          {page.title}
        </h1>
        <div style={{ fontFamily: 'var(--body-font)', fontSize: '0.95rem', lineHeight: 1.8, color: 'var(--muted-color)', whiteSpace: 'pre-wrap' }}>
          {page.content || 'No content yet.'}
        </div>
        {page.updated_at && (
          <p className="mt-12" style={{ fontFamily: 'var(--body-font)', fontSize: '0.7rem', color: 'var(--muted-color)', opacity: 0.5 }}>
            Last updated: {new Date(page.updated_at).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
          </p>
        )}
      </div>
    </div>
  );
}
